import { Vue, Component, Inject, Prop, Emit } from 'vue-property-decorator'
import { Validator } from 'vee-validate'
import { StatisticalAnalysisCommon, StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import { initialStatisticalAnalysisSidebarCheckboxState, StatisticalAnalysisSidebarCheckboxDynamicLabels, StatisticalAnalysisSidebarCheckboxModel, StatisticalAnalysisSidebarCheckboxState } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-checkbox/statistical-analysis-sidebar-checkbox.model'
import { StatisticalAnalysisSearchBySidebarEventEnum } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-search-by/statistical-analysis-sidebar-search-by.model'

@Component
export default class StatisticalAnalysisSidebarCheckbox extends Vue implements StatisticalAnalysisCommon<StatisticalAnalysisSidebarCheckboxModel> {
    @Prop() readonly label!: string
    @Prop({
        default: () => {
            return {
                active: false,
                fnToExecute: () => {}
            }
        }
    }) readonly dynamicLabel!: StatisticalAnalysisSidebarCheckboxDynamicLabels
    @Prop() readonly nameCheckbox!: string
    @Inject() externalValidator!: Validator
    @Emit()
    finish(): boolean {
        return true
    }

    state: StatisticalAnalysisSidebarCheckboxState
    constructor() {
        super()
        this.state = initialStatisticalAnalysisSidebarCheckboxState()
        this.$validator = this.externalValidator
    }

    get labelCheckbox(): string {
        return this.state.label
    }

    mounted() {
        this.state.label = this.label
        if (this.dynamicLabel.active) {
            this.$eventHub.$on(StatisticalAnalysisSearchBySidebarEventEnum.SEARCH_BY_ENTITY_CHANGE, this._onChangeEntity)
        }
        this.finish()
    }

    beforeDestroy() {
        if (this.dynamicLabel.active) {
            this.$eventHub.$off(StatisticalAnalysisSearchBySidebarEventEnum.SEARCH_BY_ENTITY_CHANGE, this._onChangeEntity)
        }
    }

    clear(): void {
        this.state = {
            ...this.state,
            active: initialStatisticalAnalysisSidebarCheckboxState().active
        }
    }

    getModel(): StatisticalAnalysisSidebarCheckboxModel {
        return {
            [this.nameCheckbox]: this.state.active
        }
    }

    private _onChangeEntity(selection: StatisticalAnalysisSidebarItemCombo): void {
        this.state.label = this.dynamicLabel.fnToExecute(selection)
    }
}
